import { useEffect, useState } from 'react'

interface IUseFocused {
  disabled?: boolean
}

export const useFocused = ({ disabled }: IUseFocused) => {
  const [focused, setFocused] = useState<boolean>(false)

  useEffect(() => {
    if (focused && disabled) {
      setFocused(false)
    }
  }, [focused, disabled])

  return { focused, setFocused }
}
